'use client';

import type { ChoiceType } from '~/model/ChoiceType';
import type { QuestionReconstructedType } from '~/model/QuestionType';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { roundToNDecimal } from '~/utils/utils';

export const RankingScaleResult = ({
  resultId,
  resultData,
  answerChoices,
  question,
}: RankingScaleResultPropsType) => {
  const t = useTranslations('SURVEY.RESULTS');
  const [isHovered, setIsHovered] = useState(0);
  const { limit_min, limit_max } = question;

  return (
    <div className="ranking-result" data-testid="ranking-result">
      {resultData && resultData.length > 0
        ? (
            <>
              <div className="result__banner">
                {resultData.map((result, i) => {
                  const choice
                    = answerChoices?.length > 0
                      && answerChoices.find(q => q['@id'] === result['@id']).title;
                  const points = roundToNDecimal(result.average);
                  return (
                    <div
                      className="ranking-result__infos"
                      key={`choice-${result.choice_id}-${resultId}`}
                    >
                      <span className="ranking-result__order">
                        {'&nbsp;'}
                        {i + 1}
                        {'&nbsp;'}
                      </span>
                      <span className="ranking-result__label">
                        {choice}
                        {' '}
                        :
                        {' '}
                        <strong>
                          {t('RANKING_POINT', {
                            count: points,
                          })}
                        </strong>
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="ranking-result__scale">
                <div className="ranking-result__scale--track" />
                <div className="ranking-result__scale__elements">
                  {resultData.map((result, i) => {
                    const points = roundToNDecimal(result.average);
                    return (
                      <div
                        key={`item-${result.choice_id}-${resultId}`}
                        onMouseEnter={() => setIsHovered(result.choice_id)}
                        onMouseLeave={() => setIsHovered(0)}
                        className="ranking-result__scale__element"
                        style={{
                          left: `${
                            ((result.average - limit_min)
                              / (limit_max - limit_min))
                            * 100
                          }%`,
                        }}
                      >
                        <p className="ranking-result__scale__element--ranking">
                          {i + 1}
                        </p>
                        <div
                          data-testid="hover-details"
                          className={`ranking-result__scale__details ${
                            result.choice_id === isHovered ? 'active' : ''
                          }`}
                        >
                          <p className="ranking-result__scale__details--title">
                            {result.choice}
                          </p>
                          <p className="ranking-result__scale__details--infos">
                            {t('RANKING_POINT', {
                              count: points,
                            })}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="vas__labels">
                <span>{roundToNDecimal(limit_min)}</span>
                <span>{roundToNDecimal(limit_max)}</span>
              </div>
            </>
          )
        : null}
    </div>
  );
};

export interface RankingScaleResultPropsType {
  resultId: number;
  resultData: Data[];
  answerChoices: ChoiceType[];
  question: QuestionReconstructedType;
}

interface Data {
  average: number;
  choice: string;
  choice_id: number;
  '@id': string;
}
